enum PickupType {
  VOID,
  COIN = "COIN",
  GEM = "GEM",
  WEAPON = "WEAPON",
  APPLE = "APPLE",
  VACUUM = "VACUUM",
  TREASURE = "TREASURE",
  CAMEL_CHEST = "CAMEL_CHEST",
}

export default PickupType;
